import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 全局样式
import '@/assets/style/index.css';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css'; // ElementPlus 暗黑主题
import 'windi.css'; // CSS 框架

// 主题系统 - 支持默认主题和暗黑主题切换
import '@/assets/styles/theme-variables.scss';
import '@/assets/styles/theme-global.scss';

// 引入 ElementPlus 及其图标
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';

import './assets/iconfont/demo/iconfont'; // 引入阿里图标库

// 您可以全局声明 Vue Data UI 组件
import 'vue-data-ui/style.css';
import { VueUiRadar } from 'vue-data-ui';

// 引入Font Awesome 5图标库  必须引入vr图标才能使用
import '@fortawesome/fontawesome-free/js/all.js';
// 引入国际化插件
import i18n from '@/locales';

// 创建 Vue 应用实例
const app = createApp(App);

// 注册 ElementPlus 图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 注册 Vue Data UI 组件
app.component('VueUiRadar', VueUiRadar);

// 使用插件和挂载应用
app.use(ElementPlus, { locale: zhCn }).use(i18n).use(store).use(router).mount('#app');
